import { InputField } from 'components'
import ProductColourSchema from './product-colour-schema'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { LoaderButton } from 'components/molecules'
import ColourInputField from 'components/molecules/colour-input-field'
import ProductColourFilterMultiSelectField from 'domains/product-colour/molecules/multiselect-field'

const propTypes = {
  handleSubmit  : PropTypes.func.isRequired,
  productColour : PropTypes.object
}

const ProductColourForm = ({ handleSubmit, productColour }) => (
  <Formik
    initialValues={{
      label                     : productColour?.label || '',
      hex_code                  : productColour.hex_code ? '#' + productColour.hex_code : '',
      product_colour_filter_ids : productColour.product_colour_filter_ids
    }}
    validationSchema={ ProductColourSchema }
    onSubmit={ handleSubmit }
  >
    {
      (formikBag) => (
        <Form>
          <InputField
            type="text"
            label="Label"
            name="label"
            required={ true }
          />

          <ColourInputField
            label='Colour'
            name='hex_code'
            required={ true }
          />

          <ProductColourFilterMultiSelectField
            label='Colour Group'
            name='product_colour_filter_ids'
            required={ true }
          />

          <LoaderButton
            isLoading={ formikBag.isSubmitting }
            block={ false }
            color='primary'
            type='submit'
            text="Save"
          />
        </Form>
      )
    }
  </Formik>
)

ProductColourForm.propTypes = propTypes

export default ProductColourForm